import { render, staticRenderFns } from "./StockAddStore.vue?vue&type=template&id=0e8bb081&scoped=true&"
import script from "./StockAddStore.vue?vue&type=script&lang=js&"
export * from "./StockAddStore.vue?vue&type=script&lang=js&"
import style0 from "./StockAddStore.vue?vue&type=style&index=0&id=0e8bb081&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8bb081",
  null
  
)

export default component.exports